module.exports = __webpack_public_path__ + "img/img-classify8.cf527823.png";